import { render, staticRenderFns } from "./Associes.vue?vue&type=template&id=3676639e&"
import script from "./Associes.vue?vue&type=script&lang=js&"
export * from "./Associes.vue?vue&type=script&lang=js&"
import style0 from "./Associes.vue?vue&type=style&index=0&id=3676639e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports